import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import aboutSecimg1 from '../assets/aboutSecimg1.png';
import aboutSecimg2 from '../assets/aboutSecimg2.png';
import aboutSecimg3 from '../assets/aboutSecimg3.png';
import proImgAboutSec from '../assets/pro-img-about-sec.png';
import imgAboutSec3 from '../assets/img-about-sec3.png';
import { Link } from 'react-router-dom';
import CmsService from '../services/API/CmsService';
import { BASE_URL } from '../services/Constant'

const MainSec2 = () => {
    const [data, setData] = useState([]);
    const [bottomData, setBottomData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

      const fetchAboutBanner = async () => {
        try {
          const res = await CmsService.aboutSection();
            const response = res.data[0];
            setData(response)
              console.log('bannerCenter',response);
              // console.log('banner',data);
        } catch (error) {
          setIsLoading(false);
          console.error("Error fetching product data:", error);
        }
      };
      const fetchAboutBottomBanner = async () => {
        try {
          const res = await CmsService.aboutBottomSection();
            const response = res.data[0];
            setBottomData(response)
              console.log('bannerCenter',response);
              // console.log('banner',data);
        } catch (error) {
          setIsLoading(false);
          console.error("Error fetching product data:", error);
        }
      };
      useEffect(() => {
        fetchAboutBottomBanner();
        fetchAboutBanner();
      }, []);
    return (
        <>
            <Container>
                <div className='row align-items-center mt-5' style={{gap:"25px 0"}}>
                    <div className='col-lg-6' >
                            <p className='about-sec2-dt-p'>
                               {data.main_description}
                            </p>
                            <div className='about-sec2-dt-p-main-div'>
                                <div className='about-sec2-dt-p-div'>
                                    <img src={`${BASE_URL}/${data.first_image}`} id='aboutSecimg1' alt='img' />
                                    <span>{data.first_title}</span>
                                </div>
                                <div className='about-sec2-dt-p-div'>
                                    <img src={`${BASE_URL}/${data.secound_image}`} id='aboutSecimg2' alt='img' />
                                    <span>{data.secound_title}</span>
                                </div>
                                <div className='about-sec2-dt-p-div'>
                                    <img src={`${BASE_URL}/${data.third_image}`} id='aboutSecimg3' alt='img' />
                                    <span>{data.third_title}</span>
                                </div>
                            </div>
                    </div>
                    <div className='col-lg-6'>
                        <div className='img-about-sec2-img'>
                            <img src={`${BASE_URL}/${data.main_image}`} id='proImgAboutSec' alt='image' />
                        </div>
                    </div>
                </div>
                <div className='row align-items-center mt-5 about-sec3' style={{gap:"25px 0"}}>
                    <div className='col-lg-6'>
                        <div className='img-about-sec3-img'>
                            <img src={`${BASE_URL}/${bottomData.image}`} id='imgAboutSec3' alt='img' />
                        </div>
                    </div>
                    <div className='col-lg-6'>
                        <p className='about-sec3-dt-p'>
                        {bottomData.description}
                        </p>
                    </div>
                </div>
                <div className='row align-items-center mt-5 mb-5'>
                    <div className='col-lg-8'>
                        <div>
                            <p className='about-sec4-dt-p'>Visit us today and experience the blend of luxury, quality, and exceptional service that sets us apart. Your satisfaction is our highest priority.</p>
                        </div>
                    </div>
                    <div className='col-lg-4 '>
                        <div className='about-sec4-dt-btn-div'>
                            <Link to="/contactus">
                        <button className='about-sec4-dt-btn'>Conatct Us</button>
                            </Link>
                        </div>
                    </div>
                </div>
            </Container>
        </>
    );
};

export default MainSec2